import PolicyHolderQuotePolicy100Coverages from '../../../../console/quotes-policies/drawers/PolicyHolderQuotePolicyP100Coverages';
import PolicyHolderQuotePolicyP250Coverages from '../../../../console/quotes-policies/drawers/PolicyHolderQuotePolicyP250Coverages';
import { P100CoveragesFromPolicy } from '../../../../console/quotes-policies/drawers/P100CoveragesFromPolicy';
import { ProductTypes } from '../../../../types';

interface Props {
  readonly product: string;
  readonly coverages: unknown;
  readonly boostVersion?: string;
  readonly policy?: any;
}

/** P100 / P250 coverage tables for quote & policy overlays. */
export function PolicyHolderCoverageBlocks({
  product,
  coverages,
  boostVersion,
  policy,
}: Props) {
  if (!coverages) return null;

  if (product === ProductTypes.p100) {
    if (boostVersion == null && policy) {
      return <P100CoveragesFromPolicy policy={policy} product={product} />;
    }
    return (
      <PolicyHolderQuotePolicy100Coverages
        coverages={coverages}
        boostVersion={boostVersion}
      />
    );
  }

  if (product === ProductTypes.p250) {
    return <PolicyHolderQuotePolicyP250Coverages coverages={coverages} />;
  }

  return null;
}
